module.exports = __webpack_public_path__ + "assets/search-f78bb8.svg";